import { defineComponent as _defineComponent } from 'vue'
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { BuyboxRegularOffer } from '@/features/buybox/types/types';
import { computed } from 'vue';
import { getTranslatableForShowOfferGraphql } from '@/helpers/offer-helper';
import { AudioTechnology, PresentationType, VideoTechnology } from '@/@types/graphql-types';
import { useI18n } from '@/helpers/composables/useI18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListOfferPresentation',
  props: {
    offer: null,
    title: null,
    seasonNumber: null,
    isLinearTVVariant: { type: Boolean },
    isLinearOffer: { type: Boolean },
    hideExtras: { type: Boolean }
  },
  emits: ['openBuyBoxInfoModal'],
  setup(__props: any) {

const props = __props as {
	offer: BuyboxRegularOffer;
	title: TitleDetail;
	seasonNumber?: number | null;
	// EXP_LINEAR_TV
	isLinearTVVariant?: boolean;
	isLinearOffer?: boolean;
	hideExtras?: boolean;
	// EXP_LINEAR_TV
};

const { tc } = useI18n();




const runtimeMins = computed(() => (props.title?.content?.runtime ? `${props.title.content.runtime}min` : null));

const isDvdOrBluRay = computed(() =>
	[PresentationType.Dvd, PresentationType.Bluray, PresentationType.Bluray_4K].includes(props.offer?.presentationType)
);

const showText = computed(() => {
	if (isDvdOrBluRay.value && props.seasonNumber != null) {
		return null;
	}
	return getTranslatableForShowOfferGraphql(props.offer, props.title.objectType);
});

const audioLanguages = computed(() => {
	if (!props.offer?.audioLanguages) return false;
	return languageArrayToString(props.offer.audioLanguages);
});

const ageRating = computed(() => {
	if (props.title.__typename !== 'Season') {
		return props.title.content.ageCertification;
	}
	return null;
});

const dolbyTechnology = computed(() => {
	return (
		props.offer?.videoTechnology.includes(VideoTechnology.DolbyVision) ||
		props.offer?.audioTechnology.includes(AudioTechnology.Dolby_5Point_1) ||
		props.offer?.audioTechnology.includes(AudioTechnology.DolbyAtmos)
	);
});

const presentationTypeLabel = computed(() => {
	switch (props.offer?.presentationType) {
		case PresentationType.Hd:
			return 'HD';
		case PresentationType['4K']:
			return '4K';
		case PresentationType.Dvd:
			return 'SD';
		case PresentationType.Bluray:
			return 'HD';
		case PresentationType.Bluray_4K:
			return '4K UHD ';
		default:
			return '';
	}
});

function languageArrayToString(languageArray: string[]) {
	const languages = languageArray.map(language => {
		return {
			language,
			name: tc(`WEBAPP_LANGUAGE_${language.toUpperCase()}`),
		};
	});
	const filteredLanguages = languages.filter((language: { language: string; name: string }) => {
		return !language.name.startsWith('WEBAPP_LANGUAGE_');
	});
	return filteredLanguages
		.map((language: { language: string; name: string }) => {
			return language.name;
		})
		.join(', ');
}

return { __sfc: true,tc, props, runtimeMins, isDvdOrBluRay, showText, audioLanguages, ageRating, dolbyTechnology, presentationTypeLabel, languageArrayToString }
}

})